"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableRowWidget = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var TableRowToolbar_1 = require("./TableRowToolbar");
var styles = __importStar(require("./TableRow.css"));
var TableRowWidget = function (_a) {
    var isTableHeader = _a.isTableHeader, attributes = _a.attributes, children = _a.children, element = _a.element;
    var _b = (0, TableRowToolbar_1.useTableRowToolbarActivationZone)(), handlers = _b.handlers, inActivationZone = _b.inActivationZone;
    var _c = __read((0, react_1.useState)(false), 2), hoverDelete = _c[0], setHoverDelete = _c[1];
    return (react_1.default.createElement("tr", __assign({ className: (0, classnames_1.default)({
            "table-header-row": isTableHeader,
        }, styles.tableRow({
            hoverDelete: hoverDelete,
        })), style: { position: "relative" } }, handlers, attributes),
        children,
        react_1.default.createElement(TableRowToolbar_1.TableRowToolbar, { inActivationZone: inActivationZone, element: element, setHoverDelete: function (nextValue) {
                setHoverDelete(nextValue);
            } })));
};
exports.TableRowWidget = TableRowWidget;
